// --- 商城管理 --- //

export default [
  {
    name: 'mallOrderList',
    path: '/supplySystem/:supplyId/base/:baseId/mallManagement/orderList/list',
    meta: { title: '商城订单' },
    component: require('business/supplySystem/mallManagement/orderList/list.vue').default
  },
  {
    name: 'mallOrderDetail',
    path: '/supplySystem/:supplyId/base/:baseId/mallManagement/orderList/detail',
    meta: { title: '商城订单详情' },
    component: require('business/supplySystem/mallManagement/orderList/detail.vue').default
  },
  {
    name: 'serviceList',
    path: '/supplySystem/:supplyId/base/:baseId/mallManagement/serviceList/list',
    meta: { title: '申请售后' },
    component: require('business/supplySystem/mallManagement/serviceList/list.vue').default
  },
  {
    name: 'serviceDetail',
    path: '/supplySystem/:supplyId/base/:baseId/mallManagement/serviceList/detail',
    meta: { title: '申请售后详情' },
    component: require('business/supplySystem/mallManagement/serviceList/detail.vue').default
  }
]
